/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoStore {
    'use strict';

    interface IMeevoStoreController {

    }

    class MeevoStoreController implements IMeevoStoreController {
        static $inject = [
            '$scope',
            '$rootScope',
            '$state',
            '$q',
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.busy.BusyService',
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            'meevo.plugins.meevoStore.MeevoStoreService',
            'meevo.ContextParams',
        ];

        constructor(
            protected $scope: angular.IScope,
            protected $rootScope: ng.IRootScopeService,
            protected $state: ng.ui.IStateService,
            protected $q: angular.IQService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected storeService: Meevo.Plugins.MeevoStore.IMeevoStoreService,
            contextParams: Meevo.ContextParamsService
        ) {
            if (contextParams && contextParams.params && contextParams.params.linkType) {
                if (contextParams.params.linkType !== LinkType.BusinessBoosters) {
                    this.$state.go(this.appSettings.ROUTE_NAMES.meevoStore + '.account', { 
                        linkType: contextParams.params.linkType 
                    });
                }
            }
        }

        public close () {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.get(this.appSettings.ROUTE_NAMES.meevoStore), null);
        }

        public goToHome () {
            this.$state.go(this.appSettings.ROUTE_NAMES.meevoStore + '.home');
        }

    }
    angular.module('meevo.plugins.meevoStore')
        .controller('meevo.plugins.meevoStore.MeevoStoreController', MeevoStoreController);
}